import PasswordInput from "@/components/PasswordInput";
import { Form } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import {
  IResetPasswordProps,
  IResetPasswordRefType,
} from "@/utils/types/resetPasswordRef";

const ResetPassword = forwardRef<IResetPasswordRefType, IResetPasswordProps>(
  (_props, ref) => {
    const [form] = Form.useForm();

    useImperativeHandle(ref, () => ({
      getFieldsValue: () => form.getFieldsValue(),
      resetFields: () => form.resetFields(),
      validateFields: () => form.validateFields(),
    }));

    return (
      <Form form={form} layout="vertical">
        <Form.Item label="Current Password" name="current_password">
          <PasswordInput />
        </Form.Item>
        <Form.Item label="New Password" name="new_password">
          <PasswordInput />
        </Form.Item>
      </Form>
    );
  }
);

export default ResetPassword;
